/* =====================================================================
   CUSTOM SUNBRELLA® BOARDING MATS — BoatMat.com
   2026-09-29. Built on the same Design Station framework as the HD DigiPrint™
   Yacht Mat and Custom Embroidered Deck Mat pages so all three feel like one
   ordering system. ONE product: Custom Sunbrella® Boarding Mat — marine-grade
   Sunbrella® fabric, embroidered with the customer's yacht logo or text.
   Sizes + prices + per-colour variant ids are the LIVE, verified product data
   (custom-embroidered-logo-sunbrella-boat-boarding-mats). Standard colours are
   Black/Navy/Tan/Gray; a separate Custom Sunbrella® Color option (same base price
   on this product — no auto upcharge) captures the shade for manual review.

   PRICE AUTHORITY: the Shopify variant id decides the price server-side.
   The amounts below are display-only and mirror the live variants.

   Colours: the verified Sunbrella® boarding colours (window.BOARDING_COLORS from
   the section) rendered flat on the live canvas preview, plus a Custom Colour option.

   MULTI-MAT ORDERS: Quantity multiplies the current configuration;
   ADD ADDITIONAL MAT banks the current configuration (its own size, color,
   artwork file, placement, quantity, notes) and starts a fresh one. ADD TO
   CART submits every configuration as its own real multipart form post to
   /cart/add (targeted at a hidden iframe, one after another) so EACH artwork
   FILE reaches its own Shopify line item, then opens the cart.
   ===================================================================== */
(function () {
'use strict';

var DEFAULT_COLOR = 'Navy';

/* The verified Sunbrella® boarding colours. window.BOARDING_COLORS is injected by
   the section. base = the Sunbrella fabric colour, trim = the bound-edge tone, vc =
   the real Shopify variant colour. The live canvas renders the mat flat in these
   colours (no external image drawn → the preview PNG capture is never tainted). */
function deckColors() {
  return (window.BOARDING_COLORS && window.BOARDING_COLORS.length) ? window.BOARDING_COLORS : [
    { c: 'Black', base: '#1b1b1e', trim: '#44444a', vc: 'Black' },
    { c: 'Navy',  base: '#17233F', trim: '#33456d', vc: 'Navy'  },
    { c: 'Tan',   base: '#C3A878', trim: '#8f7a52', vc: 'Tan'   },
    { c: 'Gray',  base: '#6E7378', trim: '#4a4e53', vc: 'Gray'  }
  ];
}
/* The custom-color marker used when the customer picks "Custom Sunbrella® Color".
   Maps to the Gray Shopify variant (same base price — the standalone boarding
   product carries NO automatic custom-colour upcharge; the true shade is captured
   as a line-item property and flagged for manual review before production). */
function customColorObj() { return { c: 'Custom Color', base: '#8a8f96', trim: '#5b6067', vc: 'Gray', custom: true }; }

/* Four verified Sunbrella® Boarding Mat sizes — live prices + per-colour Shopify
   variant ids (custom-embroidered-logo-sunbrella-boat-boarding-mats). Displayed as a
   boarding mat: w = width along the gunnel, h = 33" drop. Custom sizes → quote block. */
var SIZES = [
  { key: '20x33', w: 20, h: 33, label: '20″ × 33″', price: 199.95,
    variants: { Black: 50374397100311, Navy: 50374397133079, Tan: 50374397165847, Gray: 50374397198615 } },
  { key: '30x33', w: 30, h: 33, label: '30″ × 33″', price: 229.95,
    variants: { Black: 50374397231383, Navy: 50374397264151, Tan: 50374397296919, Gray: 50374397329687 } },
  { key: '40x33', w: 40, h: 33, label: '40″ × 33″', price: 299.95, popular: true,
    variants: { Black: 50374397362455, Navy: 50374397395223, Tan: 50374397427991, Gray: 50374397460759 } },
  { key: '60x33', w: 60, h: 33, label: '60″ × 33″', price: 499.95,
    variants: { Black: 50374397493527, Navy: 50374397526295, Tan: 50374397559063, Gray: 50374397591831 } }
];
function variantFor(size, color) {
  var vc = (color && color.vc) || 'Gray';   /* Custom Color fulfils on the Gray variant, same price */
  return size.variants[vc] || size.variants['Gray'];
}

/* Curated mat-text fonts (Patrick 2026-09-22): a small set — clean block styles,
   two scripts, and Hobo (rendered with Kavoon, the licensed Google-Fonts cut of
   the classic Hobo style; the order records the customer's chosen font name and
   production sets the final face at proof time as always). Loaded via Google
   Fonts in the section; document.fonts.load() before drawing so the canvas
   never paints a fallback face. */
/* Exactly five customer-facing styles (Patrick 2026-09-22) — simple names only,
   no technical font-family names shown, and every face has substantial stroke
   weight (prints cleanly; works for embroidery-class lettering too). Thin
   scripts (Great Vibes) and the lighter blocks (Oswald/Montserrat) removed.
   Faces underneath: Bold Block=Archivo Black (unchanged), Serif Block=Noto
   Serif 900, Brush Script=Pacifico, Bold Script=Dancing Script 700,
   Hobo=Kavoon (licensed Hobo-style cut, as before). */
var FONTS = [
  { key: 'boldblock',   label: 'Bold Block',   css: "'Archivo Black', sans-serif",   weight: '400' },
  { key: 'serifblock',  label: 'Serif Block',  css: "'Noto Serif', 'Times New Roman', serif", weight: '900' },
  { key: 'brushscript', label: 'Brush Script', css: "'Pacifico', cursive",           weight: '400' },
  { key: 'boldscript',  label: 'Bold Script',  css: "'Dancing Script', cursive",     weight: '700' }
];

/* Fee products — real Shopify variants added as SEPARATE cart lines so the
   charges reach the Shopify order total and the office record:
   - $30 Custom Sunbrella® Color Upcharge (non-standard colour, material bought separately)
   - $150 one-time NEW-logo Embroidery Digitizing fee (skipped if the exact logo is on file) */
var CUSTOM_COLOR_FEE = { variant: 67597527351575, price: 30 };
var DIGITIZING_FEE   = { variant: 50100757659927, price: 150 };
function curCustomFee() { return (S.color && S.color.custom) ? CUSTOM_COLOR_FEE.price : 0; }
function curDigiFee()   { return (S.logo && S.digitizing) ? DIGITIZING_FEE.price : 0; }
function cfgFees(m)     { return (m.custom ? CUSTOM_COLOR_FEE.price : 0) + (m.digitizing ? DIGITIZING_FEE.price : 0); }

var S = {
  customMode: false,
  size: SIZES[0],
  color: null,
  /* Step 3 is LOGO OR TEXT, never both (Patrick 2026-09-22) — a simple general
     representation, not a design program. mode drives which controls show and
     switching modes clears the other option's content from the preview. */
  mode: 'logo',
  logo: null, logoFile: null, logoName: '',
  digitizing: false,               /* customer opted to add the $150 new-logo digitizing fee */
  logoOnFile: false,               /* customer confirmed BoatMat already has the exact digitized logo */
  __pending: null,                 /* pending action while the digitizing warning is open */
  txt: { value: '', font: FONTS[0], scale: 0.5, dx: 0, dy: 0 },
  qty: 1,
  customColorName: '',             /* desired shade when Custom Sunbrella® Color is picked */
  saved: [],                       /* banked configurations */
  art: { scale: 0.6, dx: 0, dy: 0 }
};
function hasText() { return S.txt.value.trim() !== ''; }
function hasDesign() { return !!S.logo || hasText(); }

function el(id) { return document.getElementById(id); }
function money(n) { return '$' + n.toFixed(2); }

/* =============== STEP 1 — SIZES =============== */
function buildSizes() {
  var host = el('hdSizes'); if (!host) return;
  host.innerHTML = '';
  SIZES.forEach(function (z) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'szcard' + (!S.customMode && S.size.key === z.key ? ' on' : '');
    b.innerHTML = (z.popular ? '<span class="pop">MOST POPULAR</span>' : '')
      + '<span class="sz">' + z.label + '</span><span class="pr">' + money(z.price) + '</span>';
    b.onclick = function () { S.customMode = false; S.size = z; buildSizes(); syncTotals(); draw(); };
    host.appendChild(b);
  });
  /* CUSTOM SIZE is now a dedicated "Need a Custom Size?" block below the grid
     (opens the same quote modal via hdymCsqOpen) — no in-grid card. */
}

/* =============== PRICE / QTY / TOTALS =============== */
function savedTotal() { return S.saved.reduce(function (a, m) { return a + m.price * m.qty + cfgFees(m); }, 0); }
function syncTotals() {
  var p = el('hdPrice'), btn = el('hdAddCart'), sl = el('hdSizeLabel'), q = el('hdQty'),
      sc = el('hdSumColor'), tot = el('hdTotal');
  if (q) q.textContent = String(S.qty);
  if (sc) sc.textContent = colorLabel();
  var cc = curCustomFee(), dg = curDigiFee();
  var rc = el('hdFeeCustom'); if (rc) rc.hidden = cc === 0;
  var rd = el('hdFeeDigi');   if (rd) rd.hidden = dg === 0;
  var total = savedTotal();
  if (p) p.textContent = money(S.size.price) + (S.qty > 1 ? '  × ' + S.qty : '');
  if (sl) sl.textContent = S.size.label;
  var current = S.size.price * S.qty + cc + dg;
  if (btn) btn.textContent = 'ADD TO CART — ' + money(total + current);
  total += current;
  if (tot) tot.textContent = money(total);
  renderSaved();
}
window.hdymQty = function (d) { S.qty = Math.min(10, Math.max(1, S.qty + d)); syncTotals(); };

/* =============== STEP 2 — COLORS (verified Sunbrella® boarding colours + Custom) =============== */
function buildColors() {
  var host = el('hdColors'); if (!host) return;
  host.innerHTML = '';
  deckColors().forEach(function (c) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'sw' + (S.color && S.color.c === c.c ? ' on' : '');
    b.title = c.c; b.setAttribute('aria-label', 'Sunbrella color ' + c.c);
    b.style.backgroundColor = c.base;
    b.innerHTML = '<span class="swname">' + c.c + '</span>';
    b.onclick = function () { setColor(c); };
    b.dataset.cell = c.c;
    host.appendChild(b);
  });
}
/* Carpet texture per color: the swatch WebP is a real carpet-texture tile, so we
   reuse it as the mat surface pattern. Falls back to the solid hex if it can't load. */
var tileCache = {};
function tileImg(c, cb) {
  /* Boarding mats render flat (solid Sunbrella colour + bound edge), so no texture
     image is drawn — cb(null) synchronously. Keeps the preview PNG capture untainted. */
  cb(null);
}
function setColor(c) {
  S.color = c;
  var cbtn = el('hdCustomColorBtn'); if (cbtn) cbtn.classList.remove('on');
  var cwrap = el('hdCustomColorWrap'); if (cwrap) cwrap.hidden = true;
  var host = el('hdColors');
  if (host) [].forEach.call(host.children, function (b) { b.classList.toggle('on', b.dataset.cell === c.c); });
  var nm = el('hdColorName'); if (nm) nm.textContent = c.c;
  syncTotals();
  draw();
}
/* CUSTOM SUNBRELLA® COLOR — a clearly separate option (subject to availability and an
   applicable upcharge, confirmed before production). Same base price here; the true shade
   is captured as a property and flagged for manual review. */
window.hdymCustomColor = function () {
  S.color = customColorObj();
  var host = el('hdColors');
  if (host) [].forEach.call(host.children, function (b) { b.classList.remove('on'); });
  var cbtn = el('hdCustomColorBtn'); if (cbtn) cbtn.classList.add('on');
  var cwrap = el('hdCustomColorWrap'); if (cwrap) cwrap.hidden = false;
  var nm = el('hdColorName'); if (nm) nm.textContent = colorLabel();
  var ci = el('hdCustomColorInput'); if (ci) { try { ci.focus(); } catch (e) {} }
  syncTotals(); draw();
};
function wireCustomColor() {
  var ci = el('hdCustomColorInput'); if (!ci) return;
  ci.addEventListener('input', function () { S.customColorName = ci.value; var nm = el('hdColorName'); if (nm) nm.textContent = colorLabel(); syncTotals(); draw(); });
}
function colorLabel() {
  if (S.color && S.color.custom) return 'Custom Sunbrella® color' + (S.customColorName.trim() ? ' — ' + S.customColorName.trim() : '');
  return S.color ? S.color.c : DEFAULT_COLOR;
}
function colorProp() {
  if (S.color && S.color.custom) return 'Custom Color' + (S.customColorName.trim() ? ' — ' + S.customColorName.trim() : ' — (to be specified)');
  return S.color ? S.color.c : DEFAULT_COLOR;
}

/* =============== STEP 3 — LOGO =============== */
function wireUpload() {
  var inp = el('hdLogoFile'); if (!inp) return;
  inp.addEventListener('change', function () {
    var f = inp.files && inp.files[0]; if (!f) return;
    var url = URL.createObjectURL(f);
    var im = new Image();
    im.onload = function () {
      S.logo = im; S.logoFile = f; S.logoName = f.name;
      S.art = { scale: 0.6, dx: 0, dy: 0 };
      /* Pre-encode for the gallery round-trip snapshot: FileReader is async, so
         doing this at CLICK time loses the race against navigation — encode once
         here instead, long before any gallery click. */
      S.logoDataUrl = null;
      if (f.size <= 2.5 * 1024 * 1024) {
        try {
          var fr2 = new FileReader();
          fr2.onload = function () { S.logoDataUrl = fr2.result; };
          fr2.readAsDataURL(f);
        } catch (e2) { /* snapshot just won't carry the logo */ }
      }
      var th = el('hdUpTh'); if (th) { th.src = url; th.style.display = 'block'; }
      var tx = el('hdUpTxt'); if (tx) tx.textContent = f.name + ' — uploaded. Your mat preview is below.';
      var ctr = el('hdArtCtrls'); if (ctr) ctr.hidden = false;
      var dw = el('hdDigWrap'); if (dw) dw.hidden = false;
      draw();
      var pv = el('hdPreviewWrap'); if (pv && pv.scrollIntoView) pv.scrollIntoView({ behavior: 'smooth', block: 'center' });
    };
    im.onerror = function () {
      var tx = el('hdUpTxt'); if (tx) tx.textContent = 'That file could not be read as an image — please try a PNG, JPG, SVG or WEBP.';
    };
    im.src = url;
  });
}
function clearLogo() {
  S.logo = null; S.logoFile = null; S.logoName = '';
  S.digitizing = false; S.logoOnFile = false;
  var dc = el('hdDigCheck'); if (dc) dc.checked = false;
  var inp = el('hdLogoFile'); if (inp) inp.value = '';
  S.logoDataUrl = null;
  var th = el('hdUpTh'); if (th) { th.removeAttribute('src'); th.style.display = 'none'; }
  var tx = el('hdUpTxt'); if (tx) tx.textContent = 'UPLOAD YOUR LOGO OR ARTWORK HERE';
  var ctr = el('hdArtCtrls'); if (ctr) ctr.hidden = true;
  var dw = el('hdDigWrap'); if (dw) dw.hidden = true;
  syncTotals();
}
/* $150 embroidery digitizing choice */
function wireDigitizing() {
  var cb = el('hdDigCheck'); if (!cb) return;
  cb.addEventListener('change', function () { S.digitizing = cb.checked; if (cb.checked) S.logoOnFile = false; syncTotals(); });
}
function needsDigiDecision() { return !!S.logo && !S.digitizing && !S.logoOnFile; }
function digWarnOpen(action) { S.__pending = action; var m = el('hdDigWarn'); if (m) { m.hidden = false; trapModal(m, window.hdymDigWarnClose); var _df = m.querySelector('button,a,input'); if (_df) { try { _df.focus(); } catch (e) {} } } }
window.hdymDigWarnClose = function () { var m = el('hdDigWarn'); if (m) m.hidden = true; S.__pending = null; };
window.hdymDigWarnAddFee = function () {
  var cb = el('hdDigCheck'); if (cb) cb.checked = true; S.digitizing = true; S.logoOnFile = false; syncTotals();
  var a = S.__pending; var m = el('hdDigWarn'); if (m) m.hidden = true; S.__pending = null;
  if (a === 'cart') window.hdymAddToCart(); else if (a === 'add') window.hdymAddAdditional();
};
window.hdymDigWarnOnFile = function () {
  S.logoOnFile = true; S.digitizing = false; var cb = el('hdDigCheck'); if (cb) cb.checked = false; syncTotals();
  var a = S.__pending; var m = el('hdDigWarn'); if (m) m.hidden = true; S.__pending = null;
  if (a === 'cart') window.hdymAddToCart(); else if (a === 'add') window.hdymAddAdditional();
};
function nudge(dxPct, dyPct) { S.art.dx += dxPct; S.art.dy += dyPct; draw(); }
function scaleArt(f) { S.art.scale = Math.min(0.96, Math.max(0.1, S.art.scale * f)); draw(); }
function resetArt() { S.art = { scale: 0.6, dx: 0, dy: 0 }; draw(); }

/* =============== STEP 3 — ADD TEXT =============== */
function loadTxtFont(cb) {
  var f = S.txt.font;
  if (document.fonts && document.fonts.load) {
    document.fonts.load(f.weight + ' 60px ' + f.css).then(function () { cb(); }).catch(function () { cb(); });
  } else cb();
}
function wireText() {
  var inp = el('hdTextInput'), sel = el('hdTextFont');
  if (sel) {
    FONTS.forEach(function (f) {
      var o = document.createElement('option');
      o.value = f.key; o.textContent = f.label;
      sel.appendChild(o);
    });
    sel.onchange = function () {
      S.txt.font = FONTS.filter(function (f) { return f.key === sel.value; })[0] || FONTS[0];
      S.txt.dx = 0; S.txt.dy = 0;             /* recenter on font change */
      loadTxtFont(draw);
    };
  }
  if (inp) {
    inp.addEventListener('input', function () {
      S.txt.value = inp.value;
      S.txt.dx = 0; S.txt.dy = 0;             /* recenter on every wording change */
      var c = el('hdTxtCtrls'); if (c) c.hidden = S.mode !== 'text' || !hasText();
      loadTxtFont(draw);
    });
  }
}
function clearText() {
  S.txt = { value: '', font: FONTS[0], scale: 0.5, dx: 0, dy: 0 };
  var inp = el('hdTextInput'); if (inp) inp.value = '';
  var sel = el('hdTextFont'); if (sel) sel.value = FONTS[0].key;
  var c = el('hdTxtCtrls'); if (c) c.hidden = true;
}
/* Text is ALWAYS true-center (Patrick 2026-09-22) — no positioning controls,
   only a size adjustment. dx/dy stay 0; draw() centers and clamps. */
function txtScale(f) { S.txt.scale = Math.min(1.4, Math.max(0.16, S.txt.scale * f)); S.txt.dx = 0; S.txt.dy = 0; draw(); }
function updateModeUI() {
  var isLogo = S.mode === 'logo';
  var bL = el('hdModeLogo'), bT = el('hdModeText');
  if (bL) { bL.classList.toggle('on', isLogo); bL.setAttribute('aria-pressed', isLogo ? 'true' : 'false'); }
  if (bT) { bT.classList.toggle('on', !isLogo); bT.setAttribute('aria-pressed', !isLogo ? 'true' : 'false'); }
  var up = el('hdUpWrap'); if (up) up.hidden = !isLogo;
  var ac = el('hdArtCtrls'); if (ac) ac.hidden = !isLogo || !S.logo;
  var tb = el('hdTxtBox'); if (tb) tb.hidden = isLogo;
  var tc = el('hdTxtCtrls'); if (tc) tc.hidden = isLogo || !hasText();
  var dw = el('hdDigWrap'); if (dw) dw.hidden = !(isLogo && S.logo);
}
window.hdymMode = function (m) {
  if (m !== 'logo' && m !== 'text') return;
  if (S.mode === m) { updateModeUI(); return; }
  S.mode = m;
  if (m === 'logo') clearText(); else clearLogo();
  updateModeUI(); syncTotals(); draw();
};

/* =============== THE PREVIEW =============== */
/* Boarding-mat preview: a FIXED landscape frame with the mat CENTRED inside it.
   The mat HEIGHT is constant (the 33" that is the same on every size) and its
   WIDTH grows with the selected size (20″→60″), so the preview reads as a real
   boarding mat and its proportions respond to the size. Simple: the logo/text
   are auto-centred — this station has no move/scale controls. */
var MAT_H = 600, FRAME_W = 1240, PAD_Y = 96;
function matGeom() {
  var H = MAT_H;
  var W = Math.round(H * (S.size.w / S.size.h));   /* width scales with size ÷ 33 */
  var bind = Math.round(Math.min(W, H) * 0.06);    /* bound Sunbrella edge */
  return { W: W, H: H, bind: bind };
}
function draw(cb) {
  var cv = el('hdCv'); if (!cv) { if (cb) cb(); return; }
  var g = matGeom();
  var lip = Math.round(g.H * 0.03);
  cv.width = FRAME_W; cv.height = g.H + PAD_Y * 2 + lip;
  var x = Math.round((FRAME_W - g.W) / 2), y = PAD_Y;
  var ctx = cv.getContext('2d');
  ctx.clearRect(0, 0, cv.width, cv.height);
  var R = Math.round(Math.min(g.W, g.H) * 0.10);   /* soft rounded corners — fabric boarding mat */

  ctx.save(); ctx.filter = 'blur(24px)'; ctx.fillStyle = 'rgba(0,0,0,.45)';
  roundRect(ctx, x + 14, y + g.H - 6 + lip, g.W - 28, 24, 12); ctx.fill(); ctx.restore();

  var col0 = S.color || { c: DEFAULT_COLOR, base: '#17233F', trim: '#33456d' };

  /* mat body — solid Sunbrella fabric colour + soft sheen */
  ctx.save();
  roundRect(ctx, x, y, g.W, g.H, R); ctx.clip();
  ctx.fillStyle = col0.base; ctx.fillRect(x, y, g.W, g.H);
  var sheen = ctx.createLinearGradient(x, y, x, y + g.H);
  sheen.addColorStop(0, 'rgba(255,255,255,.10)'); sheen.addColorStop(0.28, 'rgba(255,255,255,0)'); sheen.addColorStop(1, 'rgba(0,0,0,.14)');
  ctx.fillStyle = sheen; ctx.fillRect(x, y, g.W, g.H);
  ctx.restore();

  /* bound Sunbrella edge (contrast binding tape) + stitch line */
  ctx.save();
  roundRect(ctx, x, y, g.W, g.H, R);
  roundRect(ctx, x + g.bind, y + g.bind, g.W - g.bind * 2, g.H - g.bind * 2, Math.max(4, R - g.bind));
  ctx.clip('evenodd');
  ctx.fillStyle = col0.trim; ctx.fillRect(x, y, g.W, g.H);
  var tsh = ctx.createLinearGradient(x, y, x, y + g.H);
  tsh.addColorStop(0, 'rgba(255,255,255,.10)'); tsh.addColorStop(1, 'rgba(0,0,0,.18)');
  ctx.fillStyle = tsh; ctx.fillRect(x, y, g.W, g.H);
  ctx.restore();
  ctx.save(); ctx.setLineDash([9, 7]); ctx.strokeStyle = 'rgba(255,255,255,.26)'; ctx.lineWidth = 2;
  roundRect(ctx, x + g.bind, y + g.bind, g.W - g.bind * 2, g.H - g.bind * 2, Math.max(4, R - g.bind)); ctx.stroke();
  ctx.restore();

  /* ============ BOARDING-MAT CONSTRUCTION OVERLAY (Patrick 2026-09-29) ============
     Reads as a real boarding mat, not a plain rectangle: 6" sandbag channels, a 12"
     sew line, the SCOOTGUARD band, and a wide central logo area. All construction
     marks use a stitch style (dark underlay + white dashes) + light label chips so
     they stay readable on ANY Sunbrella colour. 33" = full height => ppi is uniform,
     so every reference (6", 12") scales correctly with the selected size. */
  var innerX = x + g.bind * 1.3, innerY = y + g.bind * 1.3;
  var innerW = g.W - g.bind * 2.6, innerH = g.H - g.bind * 2.6;
  var ppi = g.H / 33;
  var sbW = Math.max(12, 6 * ppi);
  var sewY = innerY + 12 * ppi;
  var scootH = Math.max(22, 4.5 * ppi);
  var midL = innerX + sbW, midR = innerX + innerW - sbW, midW = Math.max(40, midR - midL);
  var lblF = Math.max(11, Math.min(26, midW * 0.14));

  function stitch(x1, y1, x2, y2) {
    ctx.save(); ctx.lineCap = 'round';
    ctx.setLineDash([]); ctx.strokeStyle = 'rgba(0,0,0,.40)'; ctx.lineWidth = Math.max(3, ppi * 0.5);
    ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
    ctx.setLineDash([Math.max(7, ppi * 1.1), Math.max(5, ppi * 0.8)]);
    ctx.strokeStyle = 'rgba(255,255,255,.92)'; ctx.lineWidth = Math.max(1.4, ppi * 0.3);
    ctx.beginPath(); ctx.moveTo(x1, y1); ctx.lineTo(x2, y2); ctx.stroke();
    ctx.restore();
  }
  function chip(txt, cx, cy, rot, fpx) {
    var f = fpx || lblF;
    ctx.save(); ctx.translate(cx, cy); if (rot) ctx.rotate(rot);
    ctx.font = '800 ' + Math.round(f) + 'px Barlow, Arial, sans-serif';
    var tw = ctx.measureText(txt).width, pad = Math.max(5, f * 0.5), h = f + pad;
    roundRect(ctx, -tw / 2 - pad, -h / 2, tw + pad * 2, h, h / 2);
    ctx.fillStyle = 'rgba(248,250,252,.94)'; ctx.fill();
    ctx.lineWidth = 1; ctx.strokeStyle = 'rgba(13,36,97,.35)'; ctx.stroke();
    ctx.fillStyle = '#0d2461'; ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText(txt, 0, 1);
    ctx.restore();
  }

  [[innerX, innerX + sbW, 0], [innerX + innerW - sbW, innerX + innerW, 1]].forEach(function (ch) {
    var a = ch[0], b = ch[1], right = ch[2];
    ctx.save(); ctx.beginPath(); ctx.rect(a, innerY, b - a, innerH); ctx.clip();
    ctx.strokeStyle = 'rgba(255,255,255,.16)'; ctx.lineWidth = Math.max(1, ppi * 0.22);
    var step = Math.max(9, ppi * 1.5);
    for (var hx = a - innerH; hx < b + innerH; hx += step) { ctx.beginPath(); ctx.moveTo(hx, innerY); ctx.lineTo(hx + innerH, innerY + innerH); ctx.stroke(); }
    ctx.restore();
    var bx = right ? a : b;
    stitch(bx, innerY + 2, bx, innerY + innerH - 2);
    chip('SANDBAG', (a + b) / 2, innerY + innerH * 0.62, -Math.PI / 2);
  });

  stitch(midL, sewY, midR, sewY);
  chip('SEW LINE', midL + midW * 0.5, sewY - lblF * 0.95);
  (function () {
    var dx = midL + Math.max(14, ppi * 1.5);
    ctx.save(); ctx.strokeStyle = 'rgba(255,255,255,.75)'; ctx.lineWidth = 1.6; ctx.setLineDash([]);
    ctx.beginPath(); ctx.moveTo(dx, innerY + 3); ctx.lineTo(dx, sewY - 2); ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(dx - 5, innerY + 3); ctx.lineTo(dx + 5, innerY + 3);
    ctx.moveTo(dx - 5, sewY - 2); ctx.lineTo(dx + 5, sewY - 2); ctx.stroke();
    ctx.restore();
    chip('12"', dx, (innerY + sewY) / 2, 0, Math.max(10, lblF * 0.82));
  })();

  ctx.save(); ctx.beginPath(); ctx.rect(midL, sewY, midW, scootH); ctx.clip();
  ctx.fillStyle = 'rgba(255,255,255,.08)'; ctx.fillRect(midL, sewY, midW, scootH);
  ctx.strokeStyle = 'rgba(255,255,255,.16)'; ctx.lineWidth = 1;
  for (var sx = midL; sx < midR; sx += Math.max(8, ppi * 1.3)) { ctx.beginPath(); ctx.moveTo(sx, sewY); ctx.lineTo(sx, sewY + scootH); ctx.stroke(); }
  ctx.restore();
  stitch(midL, sewY + scootH, midR, sewY + scootH);
  chip('SCOOTGUARD', midL + midW * 0.5, sewY + scootH / 2);

  var laW = midW * 0.94;
  var laTop = sewY + scootH + Math.max(10, ppi * 1.2), laBot = innerY + innerH - Math.max(8, ppi * 1.0);
  var laH = Math.max(24, laBot - laTop), laCx = midL + midW / 2, laCy = (laTop + laBot) / 2;
  if (S.logo) {
    var ar = S.logo.naturalHeight / S.logo.naturalWidth;
    var aw = laW * 0.98, ah = aw * ar;
    if (ah > laH * 0.94) { ah = laH * 0.94; aw = ah / ar; }
    ctx.save();
    ctx.shadowColor = 'rgba(0,0,0,.18)'; ctx.shadowBlur = 6; ctx.shadowOffsetY = 2;
    ctx.drawImage(S.logo, laCx - aw / 2, laCy - ah / 2, aw, ah);
    ctx.restore();
  }
  if (hasText()) {
    var tstr = S.txt.value.trim();
    var fsize = laH * 0.62;
    ctx.save();
    ctx.font = '800 ' + Math.round(fsize) + 'px ' + S.txt.font.css;
    var tw = ctx.measureText(tstr).width;
    if (tw > laW * 0.98) { fsize = fsize * (laW * 0.98) / tw; ctx.font = '800 ' + Math.round(fsize) + 'px ' + S.txt.font.css; }
    var hex = (S.color ? S.color.base : '#DCE0E5').replace('#', '');
    var lum = (parseInt(hex.substr(0, 2), 16) * 0.299 + parseInt(hex.substr(2, 2), 16) * 0.587 + parseInt(hex.substr(4, 2), 16) * 0.114) / 255;
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.shadowColor = 'rgba(0,0,0,.22)'; ctx.shadowBlur = 5; ctx.shadowOffsetY = 2;
    ctx.fillStyle = lum > 0.55 ? '#101820' : '#FFFFFF';
    ctx.fillText(tstr, laCx, laCy);
    ctx.restore();
  }
  if (!S.logo && !hasText()) {
    var hx0 = (col0.base || '#17233F').replace('#', '');
    var lm0 = (parseInt(hx0.substr(0, 2), 16) * 0.299 + parseInt(hx0.substr(2, 2), 16) * 0.587 + parseInt(hx0.substr(4, 2), 16) * 0.114) / 255;
    ctx.save();
    ctx.fillStyle = lm0 > 0.55 ? 'rgba(20,30,45,.5)' : 'rgba(255,255,255,.55)';
    ctx.font = '700 ' + Math.max(11, Math.round(midW * 0.075)) + 'px Barlow, sans-serif';
    ctx.textAlign = 'center'; ctx.textBaseline = 'middle';
    ctx.fillText('LOGO AREA', laCx, laCy);
    ctx.restore();
  }
  var cap = el('hdCvCap');
  if (cap) cap.textContent = 'Custom Sunbrella® Boarding Mat — ' + S.size.label + ' · ' + colorLabel();
  if (cb) cb(cv);
}
function roundRect(ctx, x, y, w, h, r) {
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.arcTo(x + w, y, x + w, y + h, r);
  ctx.arcTo(x + w, y + h, x, y + h, r);
  ctx.arcTo(x, y + h, x, y, r);
  ctx.arcTo(x, y, x + w, y, r);
  ctx.closePath();
}

function wireDrag() {
  var cv = el('hdCv'); if (!cv) return;
  var dragging = false, last = null;
  function pos(e) {
    var r = cv.getBoundingClientRect();
    var sx = cv.width / r.width, sy = cv.height / r.height;
    var t = e.touches ? e.touches[0] : e;
    return { x: (t.clientX - r.left) * sx, y: (t.clientY - r.top) * sy };
  }
  function down(e) { /* logo dragging on the mat disabled (Patrick 2026-09-29) — use the Adjust Your Logo buttons under Step 4 */ }
  function move(e) {
    if (!dragging || !last) return;
    var p = pos(e), g = matGeom();
    S.art.dx += (p.x - last.x) / (g.W - g.bind * 3.2);
    S.art.dy += (p.y - last.y) / (g.H - g.bind * 3.2);
    last = p; draw(); e.preventDefault();
  }
  function up() { dragging = false; last = null; }
  cv.addEventListener('pointerdown', down);
  window.addEventListener('pointermove', move, { passive: false });
  window.addEventListener('pointerup', up);
  cv.addEventListener('touchstart', down, { passive: false });
  window.addEventListener('touchmove', move, { passive: false });
  window.addEventListener('touchend', up);
}

/* =============== SAVED CONFIGURATIONS =============== */
function currentThumb() {
  try { var cv = el('hdCv'); return cv ? cv.toDataURL('image/jpeg', 0.5) : null; } catch (e) { return null; }
}
/* Full-quality preview capture for the order proof (Patrick 2026-09-21): the
   exact pixels the customer sees, downscaled to <=1200px wide to keep the
   upload small. Uploaded to BMOS at Add-to-Cart; the returned permanent URL
   rides the line item so the cart AND the order proof PDF can show the real
   configured mat. A failed upload never blocks the sale. */
var DP_ENDPOINT = 'https://admin.boatmat.com/public/web-intake/design-proof/preview';
function capturePreview() {
  try {
    var cv = el('hdCv'); if (!cv || !cv.width) return null;
    var MAXW = 1200;
    if (cv.width <= MAXW) return cv.toDataURL('image/png');
    var s2 = MAXW / cv.width;
    var c2 = document.createElement('canvas');
    c2.width = MAXW; c2.height = Math.round(cv.height * s2);
    c2.getContext('2d').drawImage(cv, 0, 0, c2.width, c2.height);
    return c2.toDataURL('image/png');
  } catch (e) { return null; }
}
function uploadPreview(cfg, cb) {
  if (!cfg.preview || !window.fetch) { cb(); return; }
  var ctrl = ('AbortController' in window) ? new AbortController() : null;
  var t = setTimeout(function () { if (ctrl) ctrl.abort(); }, 8000);
  fetch(DP_ENDPOINT, {
    method: 'POST', headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ png: cfg.preview, station: 'sunbrella-boarding',
      config: { size: cfg.label, sizeFt: cfg.sizeFt, color: cfg.colorC, qty: cfg.qty, placement: cfg.placement, file: cfg.logoName, text: cfg.text || '', textPlacement: cfg.textPlacement || null } }),
    signal: ctrl ? ctrl.signal : undefined
  }).then(function (r) { return r.json(); })
    .then(function (j) { clearTimeout(t); if (j && j.ok) { cfg.previewId = j.id; cfg.previewUrl = j.url; } cb(); })
    .catch(function () { clearTimeout(t); cb(); });
}
function renderSaved() {
  var host = el('hdSavedMats'); if (!host) return;
  host.hidden = S.saved.length === 0;
  host.innerHTML = '';
  S.saved.forEach(function (m, i) {
    var d = document.createElement('div');
    d.className = 'savedmat';
    d.innerHTML =
      (m.thumb ? '<img class="th" src="' + m.thumb + '" alt="">' : '<span class="th" style="background:' + m.hex + ';display:inline-block"></span>')
      + '<span class="meta"><b>Mat ' + (i + 1) + ' — ' + m.label + ' · Color ' + m.colorC + ' · Qty ' + m.qty + '</b>'
      + '<span class="d">' + (m.logoName || (m.text ? '“' + m.text + '”' : 'artwork attached')) + (m.notes ? ' · note added' : '') + '</span></span>'
      + '<span class="pr">' + money(m.price * m.qty) + '</span>'
      + '<button type="button" class="rm" data-i="' + i + '">Remove</button>';
    d.querySelector('.rm').onclick = function () { S.saved.splice(i, 1); syncTotals(); };
    host.appendChild(d);
  });
}
window.hdymAddAdditional = function () {
  var msg = el('hdCartMsg');
  if (!hasDesign()) {
    if (msg) { msg.hidden = false; msg.innerHTML = '<b>Upload this mat’s logo or add text first</b> (Step 3), then ADD ADDITIONAL MAT banks it and starts your next mat.'; }
    return;
  }
  if (msg) msg.hidden = true;
  if (needsDigiDecision()) { digWarnOpen('add'); return; }
  var color = S.color || { c: DEFAULT_COLOR, base: '#17233F', trim: '#33456d', vc: 'Navy' };
  S.saved.push({
    label: S.size.label, sizeKey: S.size.key, sizeFt: S.size.w + ' x ' + S.size.h,
    variant: variantFor(S.size, color), price: S.size.price,
    colorC: colorProp(), custom: !!(S.color && S.color.custom), customName: S.customColorName.trim(),
    digitizing: (!!S.logo && S.digitizing), logoOnFile: (!!S.logo && S.logoOnFile), hex: color.base, qty: S.qty,
    file: S.logoFile, logoName: S.logoName,
    placement: { scale: +S.art.scale.toFixed(4), dx: +S.art.dx.toFixed(4), dy: +S.art.dy.toFixed(4) },
    text: S.txt.value.trim(), textFont: S.txt.font.label,
    textPlacement: hasText() ? { font: S.txt.font.key, scale: +S.txt.scale.toFixed(4), dx: +S.txt.dx.toFixed(4), dy: +S.txt.dy.toFixed(4) } : null,
    notes: (el('hdNotes') && el('hdNotes').value || '').trim(),
    thumb: currentThumb(),
    preview: capturePreview()
  });
  /* fresh canvas for the next mat */
  clearLogo();
  clearText();
  S.mode = 'logo'; updateModeUI();
  S.qty = 1;
  if (el('hdNotes')) el('hdNotes').value = '';
  syncTotals(); draw();
  var s1 = el('hdStep1'); if (s1 && s1.scrollIntoView) s1.scrollIntoView({ behavior: 'smooth', block: 'center' });
};

/* =============== ADD TO CART (multi-config, real multipart posts) =============== */
function designId() {
  var d = new Date();
  var p = function (n) { return (n < 10 ? '0' : '') + n; };
  return 'SBM-' + d.getFullYear() + p(d.getMonth() + 1) + p(d.getDate()) + '-' +
    p(d.getHours()) + p(d.getMinutes()) + p(d.getSeconds()) + '-' +
    Math.random().toString(36).slice(2, 6).toUpperCase();
}
function cartFrame() {
  var f = el('hdymCartFrame');
  if (!f) {
    f = document.createElement('iframe');
    f.id = 'hdymCartFrame'; f.name = 'hdymCartFrame'; f.style.display = 'none';
    document.body.appendChild(f);
  }
  return f;
}
function submitConfig(cfg, done) {
  var form = document.createElement('form');
  form.method = 'post'; form.action = '/cart/add'; form.enctype = 'multipart/form-data';
  form.target = 'hdymCartFrame'; form.style.display = 'none';
  function hidden(name, value) {
    var i = document.createElement('input');
    i.type = 'hidden'; i.name = name; i.value = value;
    form.appendChild(i);
  }
  if (cfg.fee) {
    hidden('id', String(cfg.variant));
    hidden('quantity', String(cfg.qty));
    hidden('properties[Fee]', cfg.feeLabel);
    hidden('properties[For Mat]', cfg.forMat);
    if (cfg.ref) hidden('properties[_for_design_id]', cfg.ref);
    var frameF = cartFrame();
    var settledF = false;
    function finishF() { if (settledF) return; settledF = true; form.remove(); done(); }
    frameF.addEventListener('load', finishF, { once: true });
    setTimeout(finishF, 6000);
    document.body.appendChild(form); form.submit();
    return;
  }
  hidden('id', String(cfg.variant));
  hidden('quantity', String(cfg.qty));
  hidden('properties[Product]', 'Custom Sunbrella® Boarding Mats');
  hidden('properties[Size]', cfg.label);
  hidden('properties[Sunbrella Color]', cfg.colorC);
  hidden('properties[Color Type]', cfg.custom
    ? 'Custom Sunbrella® color — subject to availability and an applicable upcharge; BoatMat will confirm availability and pricing with you before production.'
    : 'Standard Sunbrella® color');
  hidden('properties[Fabric]', 'Sunbrella® marine-grade fabric');
  if (cfg.text) { hidden('properties[Mat Text]', cfg.text); hidden('properties[Text Font]', cfg.textFont); }
  if (cfg.logoName) {
    hidden('properties[Logo]', 'Yacht logo embroidered on the boarding mat.');
    if (cfg.digitizing) {
      hidden('properties[Embroidery Digitizing]', '$150.00 New-Logo Digitizing Fee — ADDED to this order (separate line).');
      hidden('properties[_bm_digitizing_review]', 'NEW LOGO — customer ADDED the $150 digitizing fee (separate line). Proceed to digitize.');
    } else {
      hidden('properties[Embroidery Digitizing]', 'Existing Digitized Logo Already on File — customer confirms BoatMat has the EXACT embroidery-ready logo (no new digitizing fee).');
      hidden('properties[_bm_digitizing_review]', 'EXISTING LOGO — customer confirms BoatMat already has the EXACT digitized logo on file. VERIFY on file; if not found, invoice the $150 digitizing fee before production.');
    }
  }
  if (cfg.custom) {
    hidden('properties[Custom Color Upcharge]', '$30.00 — non-standard Sunbrella® colour (material purchased separately); added as a separate cart line.');
    hidden('properties[_bm_custom_color_review]', 'CUSTOM SUNBRELLA COLOR (' + cfg.colorC + '): $30 upcharge added as a separate line; verify availability; fulfilled on the Gray variant as the same-price base.');
  }
  if (cfg.notes) hidden('properties[Special Notes]', cfg.notes);
  hidden('properties[_design_id]', cfg.designId || designId());
  hidden('properties[_sunbrella_color]', cfg.colorC);
  hidden('properties[_mat_size_in]', cfg.sizeFt);
  hidden('properties[_artwork_placement]', JSON.stringify(Object.assign({}, cfg.placement, { file: cfg.logoName })));
  if (cfg.textPlacement) hidden('properties[_text_placement]', JSON.stringify(Object.assign({ text: cfg.text }, cfg.textPlacement)));
  hidden('properties[_designed_at]', new Date().toISOString());
  hidden('properties[_design_station]', 'sunbrella-boarding');
  if (cfg.previewId) hidden('properties[_preview_id]', cfg.previewId);
  if (cfg.previewUrl) hidden('properties[_preview_url]', cfg.previewUrl);
  hidden('properties[_proof_status]', 'AWAITING PROOF APPROVAL');
  if (cfg.file && window.DataTransfer) {
    try {
      var fi = document.createElement('input');
      fi.type = 'file'; fi.name = 'properties[■ Artwork File]';
      var dt = new DataTransfer();
      dt.items.add(cfg.file);
      fi.files = dt.files;
      form.appendChild(fi);
    } catch (e) { /* very old browser: config still carts, file noted in placement */ }
  }
  var frame = cartFrame();
  var settled = false;
  function finish() { if (settled) return; settled = true; form.remove(); done(); }
  frame.addEventListener('load', finish, { once: true });
  setTimeout(finish, 6000);
  document.body.appendChild(form);
  form.submit();
}
window.hdymAddToCart = function () {
  var msg = el('hdCartMsg');
  if (needsDigiDecision()) { digWarnOpen('cart'); return; }
  var mats = S.saved.slice();
  if (hasDesign()) {
    var color = S.color || { c: DEFAULT_COLOR, base: '#17233F', trim: '#33456d', vc: 'Navy' };
    mats.push({
      label: S.size.label, sizeKey: S.size.key, sizeFt: S.size.w + ' x ' + S.size.h, variant: variantFor(S.size, color),
      price: S.size.price, colorC: colorProp(), custom: !!(S.color && S.color.custom), customName: S.customColorName.trim(),
      digitizing: (!!S.logo && S.digitizing), logoOnFile: (!!S.logo && S.logoOnFile),
      qty: S.qty, file: S.logoFile, logoName: S.logoName,
      placement: { scale: +S.art.scale.toFixed(4), dx: +S.art.dx.toFixed(4), dy: +S.art.dy.toFixed(4) },
      text: S.txt.value.trim(), textFont: S.txt.font.label,
      textPlacement: hasText() ? { font: S.txt.font.key, scale: +S.txt.scale.toFixed(4), dx: +S.txt.dx.toFixed(4), dy: +S.txt.dy.toFixed(4) } : null,
      notes: (el('hdNotes') && el('hdNotes').value || '').trim(),
      preview: capturePreview()
    });
  }
  if (!mats.length) {
    if (msg) { msg.hidden = false; msg.innerHTML = '<b>Please upload your logo or add your mat text first</b> — Step 3 above. Questions? Call 321.751.4636.'; }
    var st = el('hdStep3'); if (st && st.scrollIntoView) st.scrollIntoView({ behavior: 'smooth', block: 'center' });
    return;
  }
  if (msg) msg.hidden = true;
  /* build the post queue: each mat, then its fee line(s) — separate real cart lines */
  var queue = [];
  mats.forEach(function (m) {
    m.designId = designId();
    queue.push(m);
    if (m.custom) queue.push({ fee: true, variant: CUSTOM_COLOR_FEE.variant, qty: 1, feeLabel: 'Custom Sunbrella® Color Upcharge', forMat: m.label + ' / ' + m.colorC, ref: m.designId });
    if (m.digitizing) queue.push({ fee: true, variant: DIGITIZING_FEE.variant, qty: 1, feeLabel: 'New-Logo Embroidery Digitizing Fee', forMat: m.label + ' / ' + m.colorC, ref: m.designId });
  });
  var btn = el('hdAddCart');
  if (btn) { btn.disabled = true; btn.textContent = 'Adding to cart…'; }
  var i = 0, matNo = 0, matCount = mats.length;
  (function next() {
    if (i >= queue.length) { window.location.href = '/cart'; return; }
    var cfg = queue[i++];
    if (btn && matCount > 1 && !cfg.fee) { matNo++; btn.textContent = 'Adding mat ' + matNo + ' of ' + matCount + '…'; }
    if (cfg.fee) { submitConfig(cfg, next); }
    else { uploadPreview(cfg, function () { submitConfig(cfg, next); }); }
  })();
};

/* =============== CUSTOM SIZE QUOTE MODAL =============== */
var CSQ_ENDPOINT = 'https://admin.boatmat.com/public/web-intake/custom-size-quote';
function csqRow(vals) {
  var host = el('csqRows'); if (!host) return;
  var d = document.createElement('div');
  d.className = 'csq-row';
  d.innerHTML = '<input type="text" maxlength="30" placeholder="Width (e.g. 9\')" class="w">'
    + '<input type="text" maxlength="30" placeholder="Length (e.g. 4\')" class="l">'
    + '<input type="number" min="1" max="999" value="' + ((vals && vals.qty) || 1) + '" class="q" aria-label="Quantity">'
    + '<button type="button" class="rm" aria-label="Remove size">&times;</button>';
  d.querySelector('.rm').onclick = function () {
    if (el('csqRows').children.length > 1) d.remove();
    else { d.querySelector('.w').value = ''; d.querySelector('.l').value = ''; d.querySelector('.q').value = 1; }
  };
  host.appendChild(d);
}
window.hdymCsqAddRow = function () { csqRow(); };
function trapModal(m, closeFn) {
  if (!m || m.__a11y) return; m.__a11y = 1;
  m.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && closeFn) { closeFn(); return; }
    if (e.key !== 'Tab') return;
    var f = [].filter.call(m.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),select,textarea,[tabindex]:not([tabindex="-1"])'), function (x) { return x.offsetParent !== null; });
    if (!f.length) return;
    if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
    else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
  });
}
window.hdymCsqOpen = function () {
  var m = el('hdCsq'); if (!m) return;
  el('csqForm').hidden = false; el('csqDone').hidden = true;
  var err = el('csqErr'); if (err) err.hidden = true;
  if (!el('csqRows').children.length) csqRow();
  m.hidden = false;
  document.body.style.overflow = 'hidden';
  trapModal(m, window.hdymCsqClose);
  var _cf = m.querySelector('input,button,a,select,textarea'); if (_cf) { try { _cf.focus(); } catch (e) {} }
};
window.hdymCsqClose = function () {
  var m = el('hdCsq'); if (m) m.hidden = true;
  document.body.style.overflow = '';
};
window.hdymCsqSend = function () {
  var err = el('csqErr');
  function fail(t) { if (err) { err.hidden = false; err.textContent = t; } }
  var rows = [].map.call(el('csqRows').children, function (d) {
    return { width: d.querySelector('.w').value.trim(), length: d.querySelector('.l').value.trim(), qty: d.querySelector('.q').value };
  }).filter(function (r) { return r.width && r.length; });
  var name = el('csqName').value.trim(), email = el('csqEmail').value.trim(), phone = el('csqPhone').value.trim();
  if (!rows.length) return fail('Please enter at least one size — width and length.');
  if (!name) return fail('Please enter your name.');
  if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(email)) return fail('Please enter a valid email address.');
  if (!phone) return fail('Please enter your phone number.');
  if (err) err.hidden = true;
  var btn = el('csqSend');
  if (btn) { btn.disabled = true; btn.textContent = 'Sending…'; }
  fetch(CSQ_ENDPOINT, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: name, email: email, phone: phone,
      vessel: el('csqVessel').value.trim(),
      notes: el('csqNotes').value.trim(),
      company: el('csqCompany').value,
      sizes: rows,
      pageUrl: window.location.href.split('?')[0]
    })
  }).then(function (r) { return r.json().catch(function () { return { ok: r.ok }; }); })
    .then(function (j) {
      if (btn) { btn.disabled = false; btn.textContent = 'SEND QUOTE REQUEST'; }
      if (j && j.ok) { el('csqForm').hidden = true; el('csqDone').hidden = false; }
      else fail((j && j.error) || 'Something went wrong — please call 321.751.4636.');
    })
    .catch(function () {
      if (btn) { btn.disabled = false; btn.textContent = 'SEND QUOTE REQUEST'; }
      fail('Could not reach our server — please try again or call 321.751.4636.');
    });
};

/* =============== BOOT =============== */
/* =============== GALLERY ROUND-TRIP STATE (Patrick 2026-09-22) ===============
   The gallery's "Return to Previous Page" button is history.back(); the gallery
   now opens in the SAME tab so back() lands here. Browsers usually restore this
   page from the back-forward cache with everything intact — but when one
   reloads instead, this sessionStorage snapshot (saved at the moment the
   customer clicks a gallery link) puts their in-progress design back: size,
   color, quantity, text + font + placement, and the uploaded logo (kept as a
   data URL when ≤2.5MB and rebuilt into a real File so Add to Cart still
   attaches it). Snapshot expires after 60 minutes. */
var GAL_STATE_KEY = 'bmHdymGalleryState';
function saveGalleryState() {
  try {
    var st = {
      at: Date.now(), mode: S.mode, sizeKey: S.size.key, color: S.color, qty: S.qty,
      art: S.art, txt: { value: S.txt.value, fontKey: S.txt.font.key, scale: S.txt.scale, dx: S.txt.dx, dy: S.txt.dy },
      logoName: S.logoName || '', logoData: null
    };
    if (S.logo && S.logoDataUrl) st.logoData = S.logoDataUrl;
    try { sessionStorage.setItem(GAL_STATE_KEY, JSON.stringify(st)); }
    catch (e) { st.logoData = null; sessionStorage.setItem(GAL_STATE_KEY, JSON.stringify(st)); }
  } catch (e) { /* storage unavailable — bfcache still covers the common case */ }
}
function wireGallerySave() {
  ['hdGalTop', 'hdGalBottom'].forEach(function (id) {
    var a = el(id); if (a) a.addEventListener('click', saveGalleryState);
  });
}
function restoreGalleryState() {
  var raw = null;
  try { raw = sessionStorage.getItem(GAL_STATE_KEY); } catch (e) { return; }
  if (!raw) return;
  var st = null;
  try { st = JSON.parse(raw); } catch (e) { return; }
  if (!st || !st.at || Date.now() - st.at > 60 * 60000) { try { sessionStorage.removeItem(GAL_STATE_KEY); } catch (e) {} return; }
  var z = SIZES.filter(function (x) { return x.key === st.sizeKey; })[0];
  if (z) { S.size = z; buildSizes(); }
  if (st.qty >= 1 && st.qty <= 10) S.qty = st.qty;
  if (st.mode === 'text' || st.mode === 'logo') { S.mode = st.mode; updateModeUI(); }
  if (st.art && typeof st.art.scale === 'number') S.art = st.art;
  if (st.txt && st.txt.value && S.mode === 'text') {
    S.txt.value = st.txt.value;
    S.txt.font = FONTS.filter(function (f) { return f.key === st.txt.fontKey; })[0] || FONTS[0];
    S.txt.scale = st.txt.scale; S.txt.dx = 0; S.txt.dy = 0;   /* always true center */
    var ti = el('hdTextInput'); if (ti) ti.value = st.txt.value;
    var sel = el('hdTextFont'); if (sel) sel.value = S.txt.font.key;
    loadTxtFont(function () {});
  }
  if (st.color && st.color.c) {
    /* applied after the color chart loads — boot's waitColors calls us back */
    S.__restoreColor = st.color;
  }
  if (st.logoData && st.logoName && S.mode === 'logo') {
    fetch(st.logoData).then(function (r) { return r.blob(); }).then(function (blob) {
      var f = new File([blob], st.logoName, { type: blob.type || 'image/png' });
      var im = new Image();
      im.onload = function () {
        S.logo = im; S.logoFile = f; S.logoName = st.logoName;
        var th = el('hdUpTh'); if (th) { th.src = st.logoData; th.style.display = 'block'; }
        var tx = el('hdUpTxt'); if (tx) tx.textContent = st.logoName + ' — uploaded. Your mat preview is below.';
        var ctr = el('hdArtCtrls'); if (ctr) ctr.hidden = false;
        syncTotals(); draw();
      };
      im.src = st.logoData;
    }).catch(function () {});
  }
  updateModeUI(); syncTotals(); draw();
}

function boot() {
  buildSizes(); wireUpload(); wireText(); wireDrag(); wireGallerySave(); wireCustomColor(); wireDigitizing();
  restoreGalleryState();
  buildColors();
  var cols = deckColors();
  var want = S.__restoreColor && S.__restoreColor.c ? S.__restoreColor.c : DEFAULT_COLOR;
  var def = cols.filter(function (c) { return c.c === want; })[0]
    || cols.filter(function (c) { return c.c === DEFAULT_COLOR; })[0] || cols[0];
  setColor(def);
  delete S.__restoreColor;
  syncTotals();
  window.hdymNudge = nudge; window.hdymScale = scaleArt; window.hdymReset = resetArt;
  window.hdymTxtScale = txtScale;
  updateModeUI();
}
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
else boot();
})();
